/**
 * Utility functions for common operations
 */

/**
 * Capitalizes the first letter of a string and converts the rest to lowercase
 * @param str - The string to capitalize
 * @returns The capitalized string
 */
export const capitalize = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Formats a string to title case (capitalizes each word)
 * @param str - The string to format
 * @returns The title case string
 */
export const toTitleCase = (str: string): string => {
  if (!str) return str;
  return str
    .split(' ')
    .map(word => capitalize(word))
    .join(' ');
};
